import { render, staticRenderFns } from "./NotificationsConfig.vue?vue&type=template&id=a1ef4b28&"
import script from "./NotificationsConfig.vue?vue&type=script&lang=js&"
export * from "./NotificationsConfig.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsConfig.vue?vue&type=style&index=0&id=a1ef4b28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports